import React, {
  FC,
  useEffect, useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormikContext } from 'formik'

import { AppDispatch } from '@src/store/store'
import {
  selectAuthConfirmActionCard,
  selectAuthConfirmPhone, selectBackError, selectIsLoading, selectPhone,
} from '@src/store/ducks/auth/selectors'
import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
import style from '@src/pages/ActivationCard/ActivationCard.module.scss'
import { Button } from '@src/components/Button/Button'
import { numberPhoneValue } from '@src/lib/utils'
import { checkPhoneSms, confirmUserCardAct } from '@src/store/ducks/auth/thunks'

const SECONDS = 61
type ActivationPhoneCodeFormTypes = {
  code?: string;
}

export const ActivationPhoneCodeForm: FC<ActivationPhoneCodeFormTypes> = () => {
  const dispatch = useDispatch<AppDispatch>()
  const backError = useSelector(selectBackError)
  const isConfirmActionCard = useSelector(selectAuthConfirmActionCard)
  const isLoading = useSelector(selectIsLoading)
  const confirmPhone = useSelector(selectAuthConfirmPhone)
  const selectPhoneSms = useSelector(selectPhone)
  const [seconds, setSeconds] = useState(SECONDS)
  const [timerActive, setTimerActive] = useState(false)
  const { values } = useFormikContext<any>()

  useEffect(() => {
    if (seconds > 0 && timerActive) {
      setTimeout(setSeconds, 1000, seconds - 1)
    } else {
      setTimerActive(false)
      setSeconds(SECONDS)
    }
  }, [seconds, timerActive])

  const {
    setFieldValue,
  } = useFormikContext<any>()

  useEffect(() => {
    setFieldValue('isProcessingPersonalData', true)
  }, [setFieldValue])

  useEffect(() => {
    if (isConfirmActionCard) {
      setTimerActive(true)
      setSeconds(SECONDS)
    }
  }, [isConfirmActionCard])

  const sendCode = () => {
    setTimerActive(!timerActive)
    if (confirmPhone) {
      dispatch(checkPhoneSms(confirmPhone))
    }
  }
  const keyDownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.code === 'NumpadEnter' || event.code === 'Enter') {
      event.preventDefault()
      dispatch(confirmUserCardAct(values.code))
    }
  }

  return (
    <div className={style.activationPhoneForm}>
      <div className={style.inputBlock}>
        <div className={style.labelInput}>
          Введите код отправленный на номер телефона
          {' '}
          { numberPhoneValue(confirmPhone || selectPhoneSms) }
        </div>
        <FieldFormik
          className={style.positionBlock}
          name="code"
          placeholder="XXXX"
          mask="0000"
          styleError={style.inputError}
          onKeyPressBtn={keyDownHandler}
        />
      </div>
      {backError && String(backError) && (
      <div className={style.error}>
        *
        {backError}
      </div>
      )}

      <div className={style.btnBlock}>
        <div className={style.sendAgainBlock}>
          <button
            type="button"
            disabled={timerActive || isLoading}
            onClick={() => sendCode()}
            className={style.sendAgain}
          >
            Отправить код повторно
          </button>
          {timerActive && (
          <div className={style.waitTime}>
            Повторная отправка через
            {' '}
            {seconds}
          </div>
          )}
        </div>
        <Button
          loading={isLoading}
          htmlType="button"
          type="secondary"
          disabled={values.code.length < 4}
          className={style.btnSize}
          onClickFunc={() => dispatch(confirmUserCardAct(values.code))}
        >
          Активировать
        </Button>
      </div>
    </div>
  )
}
